<div class="app-account-form">
  @if (extraFields.length > 0) {
  <div class="app-account-form__extra-fields">
    <formly-form
      [fields]="extraFields"
      [form]="formDynamic"
      [model]="formDynamicModel"
    ></formly-form>

    <span class="app-account-form__extra-fields__divider"></span>
  </div>
  }

  <!-- Password Field -->
  <div class="app-account-form__field" data-account-form-password-field="password">
    <aprova-input
      _id="password"
      [inputType]="!showPassword() ? 'password' : 'text'"
      [control]="form.controls.password"
      label="Senha"
      placeholder="Digite sua senha"
      (onFocus)="showPasswordRulesTooltip('password', $event)"
      (onBlur)="clearFocusedField()"
    >
      <ng-container append>
        <aprova-icon
          [name]="!showPassword() ? 'eye-off-outline' : 'eye-outline'"
          size="20px"
          color="#9ca3af"
          class="cursor-pointer"
          (click)="toggleInputPassword()"
        />
      </ng-container>
    </aprova-input>
  </div>

  <!-- Confirm Password Field -->
  <div class="app-account-form__field" data-account-form-password-field="confirmPassword">
    <aprova-input
      _id="confirmPassword"
      [inputType]="!showConfirmPassword() ? 'password' : 'text'"
      [control]="form.controls.confirmPassword"
      label="Confirmar senha"
      placeholder="Digite sua senha novamente"
      (onInput)="validateConfirmPasswordRules()"
      (onFocus)="showPasswordRulesTooltip('confirmPassword', $event)"
      (onBlur)="clearFocusedField()"
    >
      <ng-container append>
        <aprova-icon
          [name]="!showConfirmPassword() ? 'eye-off-outline' : 'eye-outline'"
          size="20px"
          color="#9ca3af"
          class="cursor-pointer"
          (click)="toggleInputPassword(true)"
        />
      </ng-container>
    </aprova-input>
  </div>

  <!-- Password Rules Box (shown only while one of the password fields is focused) -->
  @if (focusedField()) {
    <div class="app-account-form__rules-box">
      <app-form-rules-box
        [title]="'Para sua segurança, crie uma senha forte seguindo esses requisitos'"
        [rules]="focusedField() === 'password' ? passwordRules : confirmPasswordRules"
      />
    </div>
  }

  <!-- Terms Checkbox -->
  <div class="app-account-form__terms">
    <aprova-checkbox
      [control]="form.controls.termos"
      class="font-normal text-sm leading-4 text-gray-500"
      color="#06929F"
    >
      Li e aceito os
      <a
        href="https://assets-publicos.s3.amazonaws.com/Termos+de+Uso.pdf"
        target="_blank"
        class="app-account-form__terms-link"
      >
        termos de uso
      </a>
    </aprova-checkbox>
    
    @if (form.controls['termos'].errors && !form.controls['termos'].pristine) {
    <div class="app-account-form__terms-error">
      É necessário concordar com os termos de uso para prosseguir.
    </div>
    }
  </div>

  @if(!hideRecaptcha){
  <aprova-recaptcha [recaptchaFormControl]="form.controls.recaptchaReactive" />
  }
</div>
